import { Dialog, DialogContent, DialogTrigger } from "@/shared/ui/dialog.tsx";
import { Button } from "@/shared/ui/button.tsx";
import { Upload } from "lucide-react";
import UploadImageInput from "./UploadImageInput";
import { useState } from "react";
import { useGetCatalog } from "../api";

type Props = {
  postIds: string[]
}

const UploadFormDialog = ({ postIds }: Props) => {

  const [open, setOpen] = useState(false)

  const { catalogData } = useGetCatalog(open)

  return (
    <Dialog onOpenChange={setOpen} open={open}>
      <DialogTrigger>
        <Button variant="outline">
          <Upload />
          Upload New
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-5xl">
        <UploadImageInput catalogData={catalogData ? catalogData.catalogue : []} showDialog={setOpen} postIds={postIds} />
      </DialogContent>
    </Dialog>
  )
}

export default UploadFormDialog;
